import { clearTimeouts, engine as anime } from "../../../../../animations";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline"

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const timeline = anime.timeline();

    const templateDuration = getTemplateDurationOveride({
        apiSetup: props?.apiSetup,
        tournamentId: props?.data?.event?.competitionId,
        fallback:
            _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 10,
        templateName,
        event: data?.event
    });

    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    anime({
        targets: [`#${id} .main-header`],
        duration: 500,
        easing: "easeOutQuint",
        scale: [0, 1],
        opacity: [1, 1],
        delay: 300,
    });

    anime({
        targets: [`#${id} .time-series-container span`],
        duration: 800,
        easing: "easeOutQuint",
        scale: [0, 1],
        opacity: [1, 1],
        delay: 300,
    });

    const firstHalfAElements = $(`#${id} .goals-first-half-container .team-A-container .score-container`);
    firstHalfAElements.css("height", 0);
    setTimeout(() => {
        $(firstHalfAElements).each((index, element) => {
            const maxHeight = $(element).attr("data-height");
            anime({
                targets: [element],
                duration: 800,
                easing: "easeInOutSine",
                height: [0, `${maxHeight}px`],
                delay: anime.stagger(200),
            });

            // anime({
            //     targets: $(element).find("span").toArray(), // ✅ Correct targeting
            //     duration: 800,
            //     easing: "easeInOutSine",
            //     scale: [0, 1],
            //     opacity: [0, 1],
            //     delay: anime.stagger(200),
            // });
        });
    }, 400);


    const firstHalfBElements = $(`#${id} .goals-first-half-container .team-B-container .score-container`);
    firstHalfBElements.css("height", 0);
    setTimeout(() => {
        $(firstHalfBElements).each((index, element) => {
            const maxHeight = $(element).attr("data-height");
            anime({
                targets: [element],
                duration: 800,
                easing: "easeInOutSine",
                height: [0, `${maxHeight}px`],
                delay: anime.stagger(200),
            });

            // anime({
            //     targets: $(element).find("span").toArray(), // ✅ Correct targeting
            //     duration: 800,
            //     easing: "easeInOutSine",
            //     scale: [0, 1],
            //     opacity: [0, 1],
            //     delay: anime.stagger(200),
            // });
        });
    }, 400);



    const secondHalfAElements = $(`#${id} .goals-second-half-container .team-A-container .score-container`);
    secondHalfAElements.css("height", 0);
    setTimeout(() => {
        $(secondHalfAElements).each((index, element) => {
            const maxHeight = $(element).attr("data-height");
            anime({
                targets: [element],
                duration: 800,
                easing: "easeInOutSine",
                height: [0, `${maxHeight}px`],
                delay: anime.stagger(200),
            });

            // anime({
            //     targets: $(element).find("span").toArray(), // ✅ Correct targeting
            //     duration: 800,
            //     easing: "easeInOutSine",
            //     scale: [0, 1],
            //     opacity: [0, 1],
            //     delay: anime.stagger(200),
            // });
        });
    }, 500);


    const secondHalfBElements = $(`#${id} .goals-second-half-container .team-B-container .score-container`);
    secondHalfBElements.css("height", 0);
    setTimeout(() => {
        $(secondHalfBElements).each((index, element) => {
            const maxHeight = $(element).attr("data-height");
            anime({
                targets: [element],
                duration: 800,
                easing: "easeInOutSine",
                height: [0, `${maxHeight}px`],
                delay: anime.stagger(200),
            });

            // anime({
            //     targets: $(element).find("span").toArray(), // ✅ Correct targeting
            //     duration: 800,
            //     easing: "easeInOutSine",
            //     scale: [0, 1],
            //     opacity: [0, 1],
            //     delay: anime.stagger(200),
            // });
        });
    }, 500);


    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
